import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'multicurrency'
})
export class MulticurrencyPipe implements PipeTransform {

  constructor() {}

  /**
   * Transforms the amount by applying exchange rate and formatting based on the account currency.
   * 
   * @param amount - The input amount to be converted and formatted.
   * @param exchangeRate - The exchange rate to apply.
   * @param accountCurrency - The target currency for formatting.
   * @returns Formatted string with converted amount and currency symbol.
   */
  transform(amount: any,exchangeRate: number,accountCurrency: string, fractionDigit: number): string {
   
    if (amount === null || amount === undefined) {
      return amount;
    }

    // Validate and apply exchange rate
   
    if (!exchangeRate || exchangeRate <= 0) {
      throw new Error('Invalid exchange rate');
    }
  
    const convertedAmount = Number(amount) * Number (exchangeRate);

    let finalValue; 
    
    if (Number.isInteger(convertedAmount)) {
      finalValue = new Intl.NumberFormat('en-US').format(convertedAmount); // Format as a whole number
    }else{
      finalValue = new Intl.NumberFormat('en-US', {
        minimumFractionDigits:fractionDigit,
        maximumFractionDigits: fractionDigit
      }).format(convertedAmount);
    }
    
    // Get the currency symbol for the account currency
    const formattedAmount = `${accountCurrency}${finalValue}`;

    return formattedAmount;
  }

}
